import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/nft-market/title-icon.png'
import _imports_1 from '../../assets/images/nft-market/neco-icon.png'
import _imports_2 from '../../assets/images/nft-market/tools/neco.png'
import _imports_3 from '../../assets/images/nft-market/NFISH.png'


const _withScopeId = n => (_pushScopeId("data-v-5e43f970"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nft-container" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title-icon",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "filter-section" }
const _hoisted_5 = { class: "tab-list" }
const _hoisted_6 = { class: "nft-list" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"card\" data-v-5e43f970><img class=\"neco-icon\" src=\"" + _imports_1 + "\" data-v-5e43f970><div class=\"level-wrapper\" data-v-5e43f970>5</div><img class=\"illustration\" src=\"" + _imports_2 + "\" data-v-5e43f970></div><div class=\"name-row\" data-v-5e43f970> 竹子鱼竿 ×1 </div><div class=\"price-row\" data-v-5e43f970><img class=\"token-img\" src=\"" + _imports_3 + "\" data-v-5e43f970> 20 NFISH </div>", 3)
const _hoisted_10 = [
  _hoisted_7
]

import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import NftCategoryFilter from '@/components/NFT/CategoryFilter.vue';
import NftItem from '@/components/NFT/NftItem.vue';
import { getMarketplaces } from '@/common/graphql/nft-market';
import { MarketplaceItem, marketTypesConfig, MarketType } from '@/configs/nft-market';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

const marketType = ref(marketTypesConfig[0]);
const filterNFTCategory = ref([]);
const marketplaceData = reactive({
  data: {
    id: '',
    publishedItems: '',
    soldItems: '',
    totalPublishedItemAmount: '',
  },
  currentNftList: [], // current filtered list
});

function changeMarketType(type: MarketType) {
  marketType.value = type;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  marketplaceData.currentNftList = marketplaceData.data[type.key];
}

function toDetail(id: string) {
  router.push({ name: 'nftDetail', params: { id } });
}

function initData() {
  getMarketplaces().then((res) => {
    if (!res || !res.data) return;
    const marketplaces: Array<MarketplaceItem> = res.data.marketplaces || [];
    console.log(res);
    if (marketplaces.length) {
      [marketplaceData.data] = marketplaces;
      changeMarketType(marketType.value);
    }
  });
}
initData();

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.$t('pageTitle')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(marketTypesConfig), (type) => {
          return (_openBlock(), _createBlock(_component_el_button, {
            key: type.name,
            class: _normalizeClass(["tab-btn", { active: marketType.value.name === type.name }]),
            onClick: ($event: any) => (changeMarketType(type)),
            size: "mini"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(type.name)), 1)
            ]),
            _: 2
          }, 1032, ["class", "onClick"]))
        }), 128))
      ]),
      _createVNode(NftCategoryFilter, {
        modelValue: filterNFTCategory.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterNFTCategory).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "nft-item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (toDetail('1')))
      }, _hoisted_10),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(marketplaceData).currentNftList, (item, index) => {
        return (_openBlock(), _createBlock(NftItem, {
          key: index,
          nft: item
        }, null, 8, ["nft"]))
      }), 128))
    ])
  ]))
}
}

})